export default "__VITE_ASSET__DjzOZooS__"